<script setup lang="ts">
import { RouterView, useRouter } from 'vue-router'
import { computed } from "vue";
import MenuBar from "@/components/menu/MenuBar.vue";

const router = useRouter();

const isAdmin = computed(() => {
  const current_route = router.currentRoute.value.name;
  return current_route && current_route.toString().startsWith('admin');
});

const toolbarHide = computed(() => {
  const current_route = router.currentRoute.value.name;
  return current_route && current_route.toString().startsWith('display');
});

</script>

<template>
  <template v-if="!toolbarHide">
    <main>
      <RouterView />
    </main>
    <footer>
      <MenuBar />
    </footer>
  </template>
  <template v-else>
    <RouterView />
  </template>
</template>

<style scoped>
header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem 1rem;
  gap: 1rem;
  background-color: var(--main-color);

  &.is-admin {
    background-color: var(--danger-color);

    a {
      background-color: var(--danger-color-dark);
    }
  }
}

.links {
  display: flex;
  gap: 1rem;

  a {
    color: var(--white);
    text-decoration: none;
    font-weight: bold;
    background-color: var(--main-color-dark);
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    line-height: 1rem;
  }

  a:hover {
    text-decoration: underline;
  }
}

main {
  padding-bottom: 4rem;
}

footer {
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
